import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Flex } from '@repo/pandacss/jsx';
import { Typography } from '@repo/ui/Typography';
import { renderStructuredContent } from '../../renderContext';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../types';
export type NerdTipProps = StructuredContentDocumentWithRenderer<{
  children: StructuredContentDocument;
}>;
export const NerdTip = t0 => {
  const $ = _c(9);
  const {
    props
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      bg: "yellows.lightest",
      borderTopWidth: "[4px]",
      borderTopStyle: "solid",
      borderTopColor: "primary.main",
      p: "[2rem]"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center"
    };
    t3 = <span className={css({
      fontSize: "1.5rem",
      pr: "2"
    })}>🤓</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Flex css={t2}>{t3}<Typography variant="headline.small" css={{
        letterSpacing: "[0.005rem]",
        fontWeight: "[500]"
      }}>Nerdy Tip</Typography></Flex>;
    t5 = css({
      mt: "2"
    });
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== props.children) {
    t6 = renderStructuredContent(props.children);
    $[5] = props.children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <div className={t1}>{t4}<div className={t5}>{t6}</div></div>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};